import React from 'react';
import { Modal } from '@carbon/react';
import { Logout } from '@carbon/icons-react';
import './LogoutModal.css';

const LogoutModal = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onRequestClose={onClose}
      modalHeading="Potvrda odjave"
      primaryButtonText="Odjavi se"
      secondaryButtonText="Otkaži"
      onRequestSubmit={onConfirm}
      size="sm"
      preventCloseOnClickOutside
    >
      <div className="logout-modal-content">
        <div className="logout-modal-icon">
          <Logout size={32} />
        </div>
        <p className="logout-modal-text">
          Da li ste sigurni da želite da se odjavite?
        </p>
        <p className="logout-modal-subtext">
          Bićete vraćeni na stranicu za prijavu.
        </p>
      </div>
    </Modal>
  );
};

export default LogoutModal;
